module.exports = __webpack_public_path__ + "static/media/golfer-2-a.7ad6bf4a.png";